import { Box } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box/Box';
import React from 'react';

export default function FlexBox({ children, ...rest }: BoxProps) {
  return <Box display="flex" alignItems="center" {...rest}>{children}</Box>;
}
